import React from 'react';

const Table = ({header_data, children, table_header_style, table_style, compact = false}) => {
  return (
    <table
      className={[
        'app-theme-table w-full border border-[var(--color-border)] rounded-md max-w-full mt-4 font-default',
        compact ? 'app-theme-table-compact' : 'max-h-[90%] min-h-[400px]',
        table_style,
      ].join(' ')}>
      <thead>
        <tr
          className={[
            'app-theme-table-header sticky top-0 z-10 min-w-full',
            table_header_style,
            table_header_style ? '' : 'grid',
          ].join(' ')}>
          {/* table header */}
          {header_data?.map((item, index) => {
            return (
              <th
                key={`${item?.key || item?.title || 'header'}-${index}`}
                className={[
                  ' bg-[var(--color-table-header)] text-[var(--color-text)]  flex-grow font-default text-sm  font-medium',
                  item.className,
                ].join(' ')}>
                {item?.title}
              </th>
            );
          })}
        </tr>
      </thead>

      {/* table data */}
      <tbody>{children}</tbody>
    </table>
  );
};

export default Table;
